import { Component, ElementRef, EventEmitter, Input, Output, SimpleChanges, ViewChild, ViewContainerRef } from '@angular/core';

@Component({
  selector: 'lib-adc-list-view',
  templateUrl: './adc-list-view.component.html',
  styleUrls: ['./adc-list-view.component.css']
})
export class AdcListViewComponent {
  alertMessage: string ="";
  showAlert:boolean = false;
  errorAlertMessage: string = ""; 
  showErrorAlert: boolean = false; 
  @Input() currentPageData: any;
  @Input() isLoading!: boolean; 
  @Input() dataView: any;
  @Input() showMore!: boolean;
  @Output() refresh = new EventEmitter<boolean>();dialog: any;

  @Input() pageCode!: string;
  @Output() checkedRows = new EventEmitter<any>();
  @Output() navToDashView =  new EventEmitter<any>();
  @Output() navigateTo = new EventEmitter<string>(); 
  @ViewChild('menuButton', { static: false }) menuButton!: ElementRef;
  @ViewChild('popupContainer', { read: ViewContainerRef, static: true }) popupContainer!: ViewContainerRef;

  

  // onCheckboxChange: any;
  toggleCheckAll: any;
  listViewButtons: any;
  selectedCount: any;
  totalCount: any;
  dashboardList: any;
  router: any;
  listData: any = [];

  @Output() close = new EventEmitter<void>();
  // constructor(private componentFactoryResolver: ComponentFactoryResolver) {}
  
  constructor(){}
  ngOnChanges(changes: SimpleChanges): void {
    if(changes && changes['currentPageData']?.currentValue) {
      this.listData = changes['currentPageData']?.currentValue;
      //console.log(this.listData, 'listData')
    }
  }
  performOption(option: any, entityIdKey: any, headerName: string, item: any) {
    item.showMenuOption = false;
  
    if (option.label === 'Delete') {
      this.deleteList(item);
    } else if (option.label === 'Share') {
      // this.openSharePopup(item); 
    } else if (option.label === 'Audit') {
     // console.log('Selected item for audit:', headerName);
      // this.openAuditPopup(entityIdKey, headerName);
    }
  }
  
  onCheckboxChange(event: any) {
    //console.log(event, 'checked evnt');
    this.checkedRows.emit(event);
  }
  


  // get gridTemplateColumns(): string {
  //   // Build the grid-template-columns string based on column types
  //   const baseColumns = this.dataView.columns
  //     .map((column: any) => column.type === 'checkbox' ? '25px' : '1fr')
  //     .join(' ');

  //   // Append 35px at the end if a 'menu' column exists
  //   return this.dataView.columns.some((column: any) => column.type === 'menu')
  //     ? `${baseColumns} 25px`
  //     : baseColumns;
  // }

  get gridTemplateColumns(): string {
    const baseColumns = this.dataView.columns
            .map((column: any) => {
            if (column.type === 'checkbox' || column.type === 'menu') {
                return '25px'; // Checkbox columns get a fixed width of 25px
            } else if (column.type === 'header') {
                return '1fr 1fr 1fr 1fr';
            } else if(column.columnWidth) {
              console.log('value', column.columnWidth)
              return `${column.columnWidth}rem`;
            }
            return '1fr'; // Other columns are flexible
        })
            .join(' ');
    return baseColumns;
  }

  get hasHeaderColumn(): boolean {
    return this.dataView.columns.some((column: any) => column.type === 'header');
  }

  get hasMenuColumn(): boolean {
    return this.dataView.columns.some((column: any) => column.type === 'menu');
  }

  get hasCheckboxColumn(): boolean {
    return this.dataView.columns.some((column: any) => column.type === 'checkbox');
  }

  





  openMenuOptions(item :any ) {
    item.showMenuOption = !item.showMenuOption;
  }

  navigateToView(entityIdKey :any,redirectPath :any, rowData: any) {
    const emittedObject :any = {};
    emittedObject.column = entityIdKey,
    emittedObject.redirectPath = redirectPath;
    emittedObject.data = rowData;
  //  console.log(emittedObject);
    this.navToDashView.emit(emittedObject);
  }

  typeOfkey(value: any,iconcode :any) {
    if(iconcode != null){
      return "";
    }else{
      return typeof(value) === 'number';
    }
    
  }

  /***
   * Need to revist this logic . have to modify this logic with common service implementation
   */
  deleteList(item: any): void {
    const isScheduler = item.hasOwnProperty('schedulerId');
    const isDataSource = item.hasOwnProperty('datasourceId');
    const isDataModel = item.hasOwnProperty('dataModelId');
    const isDashboard = item.hasOwnProperty('dashboardId');
    
    // Initialize alert variables
    this.showAlert = false;
    this.showErrorAlert = false;
    this.alertMessage = '';
    this.errorAlertMessage = '';
  }
  

  trackByOption(index: number, option: any): string {
    return option.label;
  }

}
